import { render, staticRenderFns } from "./Embalagem.vue?vue&type=template&id=56959d3e"
import script from "./Embalagem.vue?vue&type=script&lang=js"
export * from "./Embalagem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports